
































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import draggable from 'vuedraggable';
import baseEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import CommandToken from './CommandToken.vue';
import LiteralToken from './LiteralToken.vue';
import VariableToken from './VariableToken.vue';
import TokenListItem from './TokenListItem.vue';
import { Token, Variables, TokenType } from './Types';
import { CommandToken as CommandTokenType, VariableToken as VariableTokenType, TextLiteralToken } from './Types';
import VatsAPI from '@/Shared/VatsAPI';
import I18nMixin from '@/Shared/I18nMixin';

export default mixins(I18nMixin, LocationBasedMixin).extend({
    name: 'TemplateBuilder',
    components: {
        [TokenType[TokenType.Command]]: CommandToken,
        [TokenType[TokenType.TextLiteral]]: LiteralToken,
        [TokenType[TokenType.Variable]]: VariableToken,
        TokenListItem,
        draggable
    },
    async beforeMount() {
        this.loading = true;
        try {
            this.entities = (await VatsAPI.get<Token[]>(this.entityUrls)).data;
        }
        finally {
            this.loading = false;
        }
    },
    data() {
        return {
            entities: [] as Token[],
            TokenType,
            loading: false,
            selectedToken: null as Token | null,
        };
    },
    props: {
        templateId: { type: Number }
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/ticketTemplate/${this.templateId}/TicketTokens`;
        },
        i18nPrefix(): string {
            return 'admin.ticketTemplateBuilder';
        },
        selectedTokenIndex(): number {
            if (!this.selectedToken) {
                return -1;
            }

            return this.entities.indexOf(this.selectedToken!);
        }
    },
    methods: {
        deleteToken(token: Token) {
            const tokenIndex = this.entities.indexOf(token);
            const deleted = this.entities.splice(tokenIndex, 1);

            // Should be safe; only ever one token deleted
            if (deleted[0] === this.selectedToken) {
                this.selectedToken = null;
            }
        },
        async saveTemplate() {
            // TODO: more modularized, event-based approach to validation
            const unfinishedCommand = this.entities
                .find(token =>
                        token.tokenType === TokenType.Command
                    && (token as CommandTokenType).commandType == null
                );

            if (unfinishedCommand) {
                const translatedTitle = this.i18nLocal('unfinishedCommandTitle');
                const translatedMessage = this.i18nLocal('unfinishedCommandMessage');
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });

                return;
            }

            this.loading = true;

            try {
                const response = await VatsAPI.post<Token[]>(this.entityUrls, this.entities);
                this.entities = response.data;
            }
            catch (e) {
                const translatedTitle = this.i18nLocal('saveFailedTitle');
                const translatedMessage = this.i18nLocal('saveFailedMessage');
                this.$bvToast.toast(translatedMessage.toString(), {
                    title: translatedTitle.toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
            finally {
                this.loading = false;
            }
        },
        addNewCommand(index: number) {
            const newCommand = {
                tokenType: TokenType.Command,
                commandType: null!,
                hexCode: '',
                prefix: '',
            } as CommandTokenType;
            this.entities.splice(index + 1, 0, newCommand);
            this.selectedToken = newCommand;
        },
        addNewVariable(index: number) {
            const newVariable = {
                tokenType: TokenType.Variable,
                variableName: null!,
                hexCode: '',
            } as VariableTokenType;
            this.entities.splice(index + 1, 0, newVariable);
            this.selectedToken = newVariable;
        },
        addNewTextLiteral(index: number) {
            const newLiteral = {
                tokenType: TokenType.TextLiteral,
                contents: '',
                hexCode: '',
            } as TextLiteralToken;
            this.entities.splice(index + 1, 0, newLiteral);
            this.selectedToken = newLiteral;
        },
        cancelEdit() {
            this.$router.push({ name: 'ticketTemplates', params: { location: this.location } });
        },
        tokenSelected(token: Token) {
            this.selectedToken = token;
        },
    },
});
